<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h1>
                {{'gen_cookies_policy' | translate}}
                <button type="button" class="close clr-pri-text cursor-po-c"
                    (click)="dialogRef.close()">&times;</button>
            </h1>
            <p>{{'consent_description' | translate}}</p>
        </div>
    </div>

    <div class="row consent-collapse">
        <!-- Functional -->
        <div class="col-md-10 cursor-po-c" data-toggle="collapse" data-target="#functional">
            <p> {{'consent_functional_t' | translate}}</p>
        </div>
        <div class="col-md-2">
            <mat-slide-toggle [color]="'primary'" [checked]="true" [disabled]="true">&nbsp;</mat-slide-toggle>
        </div>
        <div id="functional" class="col-md-12 collapse">
            <p class="pb-4">{{'consent_functional_d' | translate}}</p>

            <div class="table-responsive">
                <table class="table table-bordered clr-pri-text">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Cookies</th>
                            <th>{{'consent_used_by' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>appT</td>
                            <td>{{'app_name' | translate}}</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>consent</td>
                            <td>{{'app_name' | translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="row consent-collapse">
        <!-- Marketing -->
        <div class="col-md-10 cursor-po-c" data-toggle="collapse" data-target="#marketing">
            <p> {{'consent_marketing_t' | translate}}</p>
        </div>
        <div class="col-md-2">
            <mat-slide-toggle [color]="'primary'" [checked]="consents[1]" (change)="consents[1] = $event.checked">&nbsp;
            </mat-slide-toggle>
        </div>
        <div id="marketing" class="col-md-12 collapse">
            <p class="pb-4">{{'consent_marketing_d' | translate}}</p>
        </div>
    </div>

    <div class="row my-5">
        <div class="col-md-12">
            <button class="button sm-100 mr-2" (click)="confirm()">
                {{"consent_confirm" | translate}}
            </button>
            <button class="button sm-100 mr-2" (click)="confirmAll()">
                {{"consent_confirm_all" | translate}}
            </button>
            <button class="button sm-100" (click)="dialogRef.close()">
                {{"consent_cancel" | translate}}
            </button>
        </div>
    </div>
</div>